module.exports = __webpack_public_path__ + "static/henho6-43849d1f0d3621c674e8b73939f2adb4.jpg";